var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconChatGraphics = function SvgIconChatGraphics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 1987",
    fill: "#4b4b4b",
    d: "M0 0h45.191v41.098H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5680"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\xE2ngulo 1977",
    fill: "#fff",
    opacity: 0.8,
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5679"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5678",
    clipPath: "url(#a)",
    transform: "translate(2.105 4.45)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4581",
    d: "M16.253 28.48a1.722 1.722 0 1 1-.5-1.218 1.721 1.721 0 0 1 .5 1.218m4.227-1.722a1.722 1.722 0 1 0 1.218.5 1.722 1.722 0 0 0-1.218-.5Zm-11.9 0a1.722 1.722 0 1 0 1.218.5 1.722 1.722 0 0 0-1.218-.5ZM45.189 14.01a12.034 12.034 0 0 1-2.1 6.736l2.025 6.109a1.527 1.527 0 0 1-1.934 1.931l-7.142-2.372a20.182 20.182 0 0 1-6.991 1.581c.008.161.015.323.015.486 0 6.567-6.518 11.91-14.531 11.91a17.211 17.211 0 0 1-6.7-1.335L1.9 41.025A1.445 1.445 0 0 1 .073 39.2l1.675-5.048A10.26 10.26 0 0 1 0 28.48c0-5.654 4.833-10.4 11.289-11.607a11.592 11.592 0 0 1-.366-2.863C10.924 6.285 18.61 0 28.057 0s17.132 6.284 17.132 14.01ZM27.052 28.48c0-5.459-5.617-9.9-12.522-9.9s-12.521 4.441-12.521 9.9A8.343 8.343 0 0 0 3.67 33.4a1 1 0 0 1 .142.908l-1.478 4.456 5.233-1.738a1.008 1.008 0 0 1 .733.04 15.107 15.107 0 0 0 6.23 1.315c6.9 0 12.521-4.442 12.521-9.9Zm14.113-8.49a10.108 10.108 0 0 0 2.015-5.98c0-6.618-6.785-12-15.123-12s-15.124 5.384-15.124 12a9.626 9.626 0 0 0 .365 2.607 17.95 17.95 0 0 1 1.233-.046c6.971 0 12.809 4.045 14.209 9.421a18.119 18.119 0 0 0 6.829-1.568 1.013 1.013 0 0 1 .733-.04l6.6 2.194-1.88-5.678a1 1 0 0 1 .143-.909Z",
    fill: "#4b4b4b"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconChatGraphics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-chat-graphics.08828bbc.svg";
export { ForwardRef as ReactComponent };